export enum ERRORS_TYPES {
  errorResponse,
  errorUnavailable
}
